const DOCUMENT_CATEGORIES = [
  'identity_immigration',
  'personal_financial',
  'property_assets',
  'employment_professional',
  'business_company',
  'tax_compliance',
  'legal_government_letters',
  'other_documents'
];

const SERVICE_IDS = [
  'property_golden_visa_10y',
  'property_investor_visa_2y',
  'business_investor_golden_visa_10y',
  'skilled_golden_visa_10y',
  'property_valuation',
  'dependent_visa',
  'employment_visa',
  'mofa_attestation',
  'business_setup_freezone',
  'business_setup_dubai_mainland',
  'business_setup_offshore',
  'opening_bank_accounts',
  'vat_registration',
  'vat_return_filling_quarterly',
  'vat_deregistration',
  'external_audit',
  'internal_audit',
  'ct_registration',
  'ct_filling_without_audit',
  'ct_filling_with_audit',
  'liquidation',
  'revenue_certificates',
  'tax_residency_certificate',
  'wills_drafting_reg',
  'driving_license_conversions',
  'personal_loan',
  'net_worth_certificate'
];

export const uaeConfig = {
  countryName: 'United Arab Emirates',
  countryCode: 'AE',
  categoryIds: DOCUMENT_CATEGORIES,
  serviceIds: SERVICE_IDS
};


export const countryConfigs = {
  ae: uaeConfig
};

export const SUPPORTED_COUNTRIES = Object.keys(countryConfigs);

export const DEFAULT_COUNTRY = 'ae';

/**
 * Get configuration for a specific country
 * @param {string} countryCode - ISO country code (case-insensitive)
 * @returns {Object} Country configuration
 */
export const getCountryConfig = (countryCode) => {
  const normalizedCode = countryCode?.toLowerCase();
  return countryConfigs[normalizedCode] || countryConfigs[DEFAULT_COUNTRY];
};

/**
 * Check if a country code is supported
 * @param {string} countryCode - ISO country code (case-insensitive)
 * @returns {boolean} True if country is supported
 */
export const isCountrySupported = (countryCode) => {
  const normalizedCode = countryCode?.toLowerCase();
  return SUPPORTED_COUNTRIES.includes(normalizedCode);
};
